import { create } from 'zustand';

import { RemoteConfig } from '../remote-config/config-type';

type RemoteConfigState = {
    config: RemoteConfig | undefined;
    setConfig: (config: RemoteConfig) => void;
};

export const useRemoteConfigStore = create<RemoteConfigState>((set) => ({
    config: undefined,
    setConfig: (config) => set({ config }),
}));
